// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__1mO46","sectionsWrapper":"style_sectionsWrapper__1gndE","tableWrapper":"style_tableWrapper__3M1oo","tableTitle":"style_tableTitle__1-9N2"};